import { styled } from '@mui/material/styles';
import Select from "@mui/material/Select";
import FormHelperText from '@mui/material/FormHelperText';
import FormControl  from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

const SelectField = styled(Select)({
    background: 'white',
    // background: '#f1f2f4',
    borderRadius: '6px',
    // borderRadius: `16px`,
    color: '#000',
    '& .MuiFormControl-root': {
      // color: "rgb(0 0 0 / 80%)",
      color: '#000',
    },
    '& .MuiInputBase-input': {
      // color: "rgb(0 0 0 / 80%)",
      color: '#000',
    },
    '& .MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
      padding: '10px 14px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      // borderColor: (theme) theme.colors?.grey400
      borderColor: (theme) => theme.palette.primary.main
    },

    '&:hover $notchedOutline': {
      // borderColor: theme.colors?.primaryLight
      borderColor: (theme) => theme.palette.primary.main
    },
    '&.MuiInputBase-multiline': {
      padding: 1
    },
    "&  .MuiFormHelperText-root.Mui-error": { //<--- here
      // backgroundColor: "red",
      margin:0,
      paddingLeft: 10
    },
    
    // '& .MuiOutlinedInput-root': {
    //     '& fieldset': {
    //         borderColor: (theme) => theme.palette.primary.main
    //     },
    //     '&:hover fieldset': {
    //         borderColor: (theme) => theme.palette.primary.main
    //     },
    //     '&.Mui-focused fieldset': {
    //         borderColor: (theme) => theme.palette.primary.main
    //     },
    //   },
    '& .Mui-disabled': {
      backgroundColor: '#e9ecef',
      cursor: 'not-allowed',
      pointerEvents: 'all',
      ':hover': {
        backgroundColor: '#e9ecef',
      }
    },
    input:  {
      fontWeight: 500,
      background: 'white',
      // background: '#f1f2f4',
      padding: '15.5px 14px',
    //   borderRadius: `16px`,
        borderRadius: '8px',
  
      '&.MuiInputBase-inputSizeSmall': {
        padding: '10px 14px',
        '&.MuiInputBase-inputAdornedStart': {
          paddingLeft: 0
        }
      }
    },
  
    inputAdornedStart: {
      paddingLeft: 4
    },
    notchedOutline: {
    //   borderRadius: `16px`
    }
});

const FormLabelStyled = styled(FormLabel)({
    padding: '4px',
    fontWeight: 600,
    color: '#000',
    fontSize: 16,
});

const ITEM_HEIGHT = 80;
const ITEM_PADDING_TOP = 8;
const CustomMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const SelectInput = (props) => {

    const {
        labelAbove = false,
        labelLeft = false,
        fullWidth = true,
        gridProps = {
            left: {
              xs: 12,
              md: 6
            },
            right: {
              xs: 12,
              md: 6
            }
        },
        formControlClasses = "",
        helperText,
        useCustomMenuProps = true,
        MenuProps = useCustomMenuProps ? CustomMenuProps : {},
        displayEmpty = true,
        ...other
    } = props;

    const RenderSelectField = () => (
      <SelectField
          displayEmpty={displayEmpty}
          MenuProps={{
            disableScrollLock: false,
            ...MenuProps,
          }}
          {...other}
          label={labelAbove || labelLeft ? null : props.label}
        >
          {props.children}
      </SelectField>
    )

    return (
        <>
        <FormControl fullWidth={fullWidth} className={formControlClasses}
       
        >

              {labelAbove ? (
                <FormLabelStyled>{`${props.label} ${props.required ? '*' : ''}`}</FormLabelStyled>
              ) : (
                !labelLeft && <>
                  {props?.label ? (<InputLabel shrink>{`${props.label} ${props.required ? '*' : ''}`}</InputLabel>) : null}
                </>
              )}

                {labelLeft ? (
                  <>
                    <Grid container>
                      <Grid className="text-vertical" item {...gridProps.left}>
                        <Typography variant="strong" component="strong" >{props.label}</Typography> 
                      </Grid>
                      <Grid item {...gridProps.right}>
                                <SelectField
                                  displayEmpty={displayEmpty}
                                  MenuProps={{
                                    disableScrollLock: false,
                                    ...MenuProps,
                                  }}
                                  {...other}
                                  label={labelAbove || labelLeft ? null : props.label}
                                >
                                  {props.children}
                              </SelectField>
                      </Grid>
                    </Grid>
                  </>
                ) : (
                        <SelectField
                          displayEmpty={displayEmpty}
                          MenuProps={{
                            disableScrollLock: false,
                            ...MenuProps,
                          }}
                          {...other}
                          label={labelAbove || labelLeft ? null : props.label}
                        >
                          {props.children}
                      </SelectField>
                )}      

              {
                props.error && (
                  <Box>
                    <FormHelperText error>
                        {helperText}
                    </FormHelperText>

                  </Box>
                )
              }
        </FormControl>
        </>
    )
}

export default SelectInput